import { Navigate, useLocation } from "react-router-dom";
import ServicePage from "../components/ServicePage";
import { SERVICE_PAGES } from "../data/servicePages";

export default function ServiceRoute() {
  const { pathname } = useLocation();
  const page = SERVICE_PAGES.find((p) => p.path === pathname.replace(/\/+$/, ""));
  if (!page) return <Navigate to="/" replace />;
  return <ServicePage key={page.path} page={page} />;
}
